'use strict';

// Instance Methods
require('./after');
require('./cancel');
require('./debounce');
require('./delay');
require('./every');
require('./lazy');
require('./lock');
require('./memoize');
require('./once');
require('./partial');
require('./throttle');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/index.js
// module id = 636
// module chunks = 0